export default __webpack_public_path__ + "static/media/amertrad10.88f3256f.png";